import AppConfigurationService from '../app-configuration-service/app-configuration-service';
import { consentService } from '../consent-service/consent-service';
import { BrandUtil } from '../../components/utils/brand-util/brand-util';
import AuthenticationService from '../authentication-service/authentication-service';
import { EU_CHAT_BOT_URLS, SOPHUS_CHAT_COUNTRIES } from '../../constants';

class ScriptService {
    public loadOneLinkTranslationScript() {
        if (document.getElementById('oneLinkTranslationScript')) {
            return;
        }

        const script = document.createElement('script');
        script.id = 'oneLinkTranslationScript';
        script.setAttribute(
            'referrerpolicy',
            'no-referrer-when-downgrade'
        );
        script.setAttribute('type', 'text/javascript');
        script.setAttribute(
            'src',
            'https://www.onelink-edge.com/moxie.min.js'
        );
        script.setAttribute('data-oljs', 'PE065-56C9-59DE-5734');
        document.head.appendChild(script);
    }

    public setMouseflowScript(removeMouseflowEleIfPresent = false) {
        const appConfiguration = new AppConfigurationService().getAppConfiguration();

        const medalliaMouseflowIntegration = () => {
            const win = window as any;
            const isMedalliaMouseflowSessionUnavailable = !win.medallia
                ?.mouseflowSessionId;
            if (isMedalliaMouseflowSessionUnavailable) {
                const mouseflowInterval = setInterval(() => {
                    const mouseflow = win.mouseflow;
                    if (mouseflow?.getSessionId()) {
                        win.medallia = win.medallia || {};
                        win.medallia.mouseflowSessionId = mouseflow.getSessionId();
                        clearInterval(mouseflowInterval);
                    }
                }, 100);
            }
        };

        if (appConfiguration.mouseflowId) {
            const script = document.createElement('script');
            script.id = 'mouseflowId';
            script.defer = true;
            script.src = `//cdn.mouseflow.com/projects/${appConfiguration.mouseflowId}.js`;
            script.async = true;
            if (
                consentService.nonEssentialScriptsAllowed() &&
                !removeMouseflowEleIfPresent
            ) {
                if (
                    appConfiguration.countryCode?.toLowerCase() == 'us' ||
                    appConfiguration.countryCode?.toLowerCase() == 'ca' ||
                    (appConfiguration.countryCode?.toLowerCase() == 'mx' &&
                        appConfiguration.environment !== 'prod')
                ) {
                    script.type = 'text/plain';
                    script.className = 'optanon-category-2-4';
                } else {
                    script.type = 'text/javascript';
                    script.className = 'optanon-category-2-4';
                }
                document.body.appendChild(script);
                document.getElementsByTagName('body')[0].appendChild(script);
                medalliaMouseflowIntegration();
            } else if (removeMouseflowEleIfPresent) {
                const mouseflowEle = document.getElementById('mouseflowId');
                mouseflowEle &&
                    document
                        .getElementsByTagName('body')[0]
                        .removeChild(mouseflowEle);
            }
        }
    }

    public loadFMA(applicationId: string) {
        const appConfigurationService = new AppConfigurationService();
        const appConfiguration = appConfigurationService.getAppConfiguration();
        const origin = `${window.location.protocol}//${window.location.hostname}${appConfiguration.root}`;
        const fmaTag = document.createElement('script');
        const brand = new BrandUtil().getBrandName(appConfiguration.brand);
        const propertyKey =
            appConfiguration.countryCode?.toLowerCase() == 'us'
                ? 'eu_dashboard'
                : `global_owner_${brand}`;

        fmaTag.src = appConfiguration.fmaUrl;
        fmaTag.setAttribute('data-enable-guest-guid', 'false');
        fmaTag.setAttribute('data-fma-script', '');
        fmaTag.setAttribute(
            'data-ibm-cid',
            process.env.REACT_APP_IBM_CID || ''
        );
        fmaTag.setAttribute('data-property-key', propertyKey);
        fmaTag.setAttribute('data-region', appConfiguration.fmaRegion);
        fmaTag.setAttribute('data-fs-url', appConfiguration.apimUrl);
        fmaTag.setAttribute('data-logout-url', origin);
        fmaTag.setAttribute('data-origin-url', '');
        fmaTag.setAttribute(
            'data-lang',
            appConfiguration.languageRegionCode.split('-').join('_')
        );
        if (process.env.REACT_APP_B2C_FLAG === 'true') {
            fmaTag.setAttribute(
                'data-client-id',
                process.env.REACT_APP_AZURE_B2C_ID || ''
            );
            // fmaTag.setAttribute(
            //     'data-base-path',
            //     appConfigurationService.rootToUse(
            //         appConfiguration.root,
            //         appConfiguration.brand,
            //         appConfiguration.languageRegionCode
            //     )
            // );
            // fmaTag.setAttribute(
            //     'data-base-path-redirection',
            //     (
            //         appConfiguration.brand &&
            //         appConfiguration.languageRegionCode &&
            //         appConfiguration.root ===
            //             `/${appConfiguration.brand}/${appConfiguration.languageRegionCode}/`
            //     ).toString()
            // );
        } else if ('prod' !== process.env.REACT_APP_ACTIVE_PROFILE) {
            fmaTag.setAttribute(
                'data-ibm-url',
                AuthenticationService.getIbmUrl(brand)
            );
        }
        if (applicationId) {
            fmaTag.setAttribute('data-app-id', applicationId);
            document.body.appendChild(fmaTag);
        }
    }

    public loadDynatraceTags(removeFlag?: boolean) {
        const appConfiguration = new AppConfigurationService().getAppConfiguration();

        if (removeFlag) {
            const dynatraceRuxEle = document.getElementById('dtjsagent');
            const dynatraceEle = document.getElementById('dynatraceid');
            dynatraceRuxEle &&
                document
                    .getElementsByTagName('body')[0]
                    .removeChild(dynatraceRuxEle);
            dynatraceEle &&
                document
                    .getElementsByTagName('body')[0]
                    .removeChild(dynatraceEle);
            return;
        }

        if (!consentService.nonEssentialScriptsAllowed()) {
            return;
        }

        const dynaTraceTag = document.createElement('script');
        dynaTraceTag.setAttribute('id', 'dynatraceid');
        dynaTraceTag.setAttribute('crossorigin', 'anonymous');

        if (
            appConfiguration.countryCode?.toLowerCase() == 'us' ||
            appConfiguration.countryCode?.toLowerCase() == 'ca' ||
            (appConfiguration.countryCode?.toLowerCase() == 'mx' &&
                appConfiguration.environment !== 'prod')
        ) {
            dynaTraceTag.setAttribute('type', 'text/plain');
            dynaTraceTag.setAttribute('class', 'optanon-category-2-4');
        } else {
            dynaTraceTag.setAttribute('type', 'text/javascript');
            dynaTraceTag.setAttribute('class', 'optanon-category-2-4');
        }

        if (appConfiguration.environment === 'prod') {
            dynaTraceTag.setAttribute(
                'src',
                'https://www.ford.com/9575fda107dc0f5_complete.js'
            );
        }
        if (appConfiguration.environment === 'uat') {
            dynaTraceTag.setAttribute(
                'src',
                'https://wwwqa.ford.com/fdb3923c9a9989dd_complete.js'
            );
        }

        document.getElementsByTagName('body')[0].appendChild(dynaTraceTag);
    }

    public loadOneTrustCookieBanner() {
        const appConfiguration = new AppConfigurationService().getAppConfiguration();
        const oneTrustTag = document.createElement('script');
        oneTrustTag.setAttribute(
            'src',
            'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
        );
        oneTrustTag.setAttribute('type', 'text/javascript');
        oneTrustTag.setAttribute('charset', 'UTF-8');
        oneTrustTag.dataset.documentLanguage = 'true';
        const country = appConfiguration.countryCode?.toLowerCase() ?? '';
        const brand = appConfiguration.brand === 'lincoln' ? 'lincoln' : 'ford';
        const isProd = appConfiguration.environment === 'prod';

        const domainScriptMap: Record<string, Record<string, string>> = {
            lincoln: {
                us: 'e68b490a-bbfa-4cf0-a492-de3c092da1df',
                ca: 'a68d239d-f6d3-439b-b094-f643bf6530b7',
                mx: isProd
                    ? '019d2b6e-8763-75a0-be3e-5184669f7f95'
                    : '019d2b6e-8763-75a0-be3e-5184669f7f95-test',
            },
            ford: {
                us: '474f6f1e-8e77-40c9-97fd-ab58b6e08de0',
                ca: '36e4189f-d97e-4c35-9018-e1755788c7dc',
                mx: isProd
                    ? '019d2b32-cf71-79bf-b26c-24cfbc351384'
                    : '019d2b32-cf71-79bf-b26c-24cfbc351384-test',
            },
        };
        const domainScript = domainScriptMap[brand]?.[country];
        if (domainScript) {
            oneTrustTag.setAttribute('data-domain-script', domainScript);
        }
        document.getElementsByTagName('body')[0].appendChild(oneTrustTag);
    }

    public loadAnalyticsScript() {
        const appConfiguration = new AppConfigurationService().getAppConfiguration();

        if (!appConfiguration.analyticsEmbedScriptUrl) {
            return;
        }

        if (!consentService.nonEssentialScriptsAllowed()) {
            return;
        }

        const analyticsTag = document.createElement('script');
        analyticsTag.src = appConfiguration.analyticsEmbedScriptUrl;
        if (
            appConfiguration.countryCode?.toLowerCase() == 'us' ||
            appConfiguration.countryCode?.toLowerCase() == 'ca' ||
            (appConfiguration.countryCode?.toLowerCase() == 'mx' &&
                appConfiguration.environment !== 'prod')
        ) {
            analyticsTag.type = 'text/plain';
            analyticsTag.className = 'optanon-category-2-4';
        } else {
            analyticsTag.type = 'text/javascript';
            analyticsTag.className = 'optanon-category-2-4';
        }

        document.body.appendChild(analyticsTag);
    }

    public loadMcpScript() {
        const appConfiguration = new AppConfigurationService().getAppConfiguration();
        const hostname =
            typeof window !== 'undefined'
                ? window.location?.hostname?.toLowerCase()
                : '';
        const isLocalHostname =
            hostname === 'localhost' ||
            hostname.startsWith('127.') ||
            hostname.includes('.local.') ||
            hostname.endsWith('.local');

        if (isLocalHostname || !consentService.nonEssentialScriptsAllowed()) {
            return;
        }

        if (document.getElementById('mcpScriptId')) {
            return;
        }

        const mcpScript = document.createElement('script');
        mcpScript.setAttribute('id', 'mcpScriptId');

        const country = appConfiguration.countryCode?.toLowerCase();
        const scriptType =
            country === 'us' ||
            country === 'ca' ||
            (country === 'mx' && appConfiguration.environment !== 'prod')
                ? 'text/plain'
                : 'text/javascript';

        if (appConfiguration.environment === 'prod') {
            mcpScript.setAttribute('async', '');
            mcpScript.setAttribute('type', scriptType);
            mcpScript.setAttribute(
                'src',
                '//cdn.evgnet.com/beacon/fordeurope/ford_retail_eu_production/scripts/evergage.min.js'
            );
        } else {
            mcpScript.setAttribute('async', '');
            mcpScript.setAttribute('type', scriptType);
            mcpScript.setAttribute(
                'src',
                '//cdn.evgnet.com/beacon/fordeurope/ford_retail_eu_development/scripts/evergage.min.js'
            );
        }

        mcpScript.setAttribute('class', 'optanon-category-2-4');

        document.body.appendChild(mcpScript);
    }

    public loadChatBot() {
        const {
            environment,
        } = new AppConfigurationService().getAppConfiguration();
        const env =
            environment === 'prod' || environment === 'uat'
                ? environment
                : 'qa';

        const scriptBlock = document.createElement('script');
        const chatBotUrls: Record<string, string> = {
            qa: 'https://fordtccendpointqa-h5gedwcmfyh9eubc.a02.azurefd.net/chatwidget/cxhubchat.js',
            uat: 'https://fordtccendpointuat-bvaufahhb2ecc0br.a02.azurefd.net/chatwidget/cxhubchat.js',
            prod: 'https://fordtccendpointprod-g4a9atf5acdxarc6.a01.azurefd.net/chatwidget/cxhubchat.js',
        };
        const url = chatBotUrls[env] ?? chatBotUrls.uat;
        scriptBlock.setAttribute('src', url);
        scriptBlock.setAttribute('class', 'optanon-category-2-4');
        scriptBlock.defer = true;
        document.head.appendChild(scriptBlock);
        const win: any = window;
        scriptBlock.addEventListener(
            'load',
            () =>
                win?.CXHubFord.Dynamics.Omnichannel.CXHubChatLogic.loadChatWidgetFromAzureBlob(
                    env
                ),
            true
        );
    }

    public loadSophusScript() {
        const appConfiguration = new AppConfigurationService().getAppConfiguration();
        const countryCode = appConfiguration.countryCode;
        const isSophusScriptAvailable = Object.prototype.hasOwnProperty.call(
            SOPHUS_CHAT_COUNTRIES,
            countryCode
        );

        if (!isSophusScriptAvailable) {
            return;
        }

        const getCountryScript = () => {
            if (process.env.REACT_APP_ACTIVE_PROFILE === 'prod') {
                return SOPHUS_CHAT_COUNTRIES[countryCode];
            }
            return SOPHUS_CHAT_COUNTRIES.default;
        };

        const sophusTag = document.createElement('script');
        sophusTag.async = true;
        sophusTag.setAttribute('src', getCountryScript());

        if (
            appConfiguration.countryCode?.toLowerCase() == 'us' ||
            appConfiguration.countryCode?.toLowerCase() == 'ca' ||
            (appConfiguration.countryCode?.toLowerCase() == 'mx' &&
                appConfiguration.environment !== 'prod')
        ) {
            sophusTag.type = 'text/plain';
            sophusTag.setAttribute('class', 'optanon-category-2-4');
        } else {
            sophusTag.type = 'text/javascript';
            sophusTag.setAttribute('class', 'optanon-category-2-4');
        }

        document.body.appendChild(sophusTag);
    }

    public loadEvidonCookieBanner() {
        if (process.env.REACT_APP_ACTIVE_PROFILE !== 'prod') {
            return;
        }

        const appConfiguration = new AppConfigurationService().getAppConfiguration();
        if (appConfiguration.countryCode === 'ca') {
            const evidonTag = document.createElement('script');
            evidonTag.setAttribute('id', 'evidon-script');
            evidonTag.setAttribute('src', 'https://c.evidon.com/dg/dg.js');
            evidonTag.setAttribute('companyid', '1063');
            const evidonInnerScriptTag = document.createElement('script');
            evidonInnerScriptTag.setAttribute('id', 'evidon-inner-script');
            evidonInnerScriptTag.innerHTML =
                '!function(e){function n(e,n,o){var i=document,t="script",c=i.getElementsByTagName(t)[0];c||(c=i.head);var s=i.createElement(t);s.async=o,s.id=e,s.src=n,s.charset="utf-8",c.parentNode.insertBefore(s,c)}window.evidon={},window.evidon.id=e,window.evidon.test=!1;var o="//c.evidon.com/",i=function e(){var n=window.location.hostname.split(".");if(2===n.length)i=n[0];else if(n.length>2){var o,t=n[n.length-2];i=-1!==["co","com","info","web","info","gov","edu","biz","net","org"].indexOf(o=t)||-1!==["uk","us","fr","es","de","at","au","ae","be","br","ca","ch","cn","co","cz","dk","eg","eu","fi","gb","gr","hk","hr","hu","ie","in","jp","mx","nl","no","nz","pl","ro","ru","se"].indexOf(o)?n[n.length-3]:t}return i}(),t=o+"sitenotice/";n("evidon-notice",t+"evidon-sitenotice-tag.js",!1),n("evidon-location",o+"geo/country.js",!0),n("evidon-themes",t+e+"/snthemes.js",!0),i&&n("evidon-settings",t+e+"/"+i+(window.evidon.test?"/test":"")+"/settingsV2.js",!0),window.evidon.priorConsentCallback=function(e,n,o){},window.evidon.closeCallback=function(){},window.evidon.consentWithdrawnCallback=function(){},window.evidon.consentDeclinedCallback=function(){window.evidon.notice.dropSuppressionCookie(30)}}(1063);';
            document.body.appendChild(evidonTag);
            document.body.appendChild(evidonInnerScriptTag);
        }
    }

    public loadEuHelpRouterScript() {
        const helpRouterScript = document.createElement('script');
        const helpRouterLink = document.createElement('link');
        const helpRouterFonts = document.createElement('link');
        const helpRouterIcons = document.createElement('link');
        const helpRouterVariables = document.createElement('link');
        helpRouterFonts.setAttribute('rel', 'stylesheet');
        helpRouterFonts.setAttribute(
            'href',
            EU_CHAT_BOT_URLS.FORD_ANTENNA_SWAP_CSS
        );
        helpRouterIcons.setAttribute('rel', 'stylesheet');
        helpRouterIcons.setAttribute('href', EU_CHAT_BOT_URLS.FORD_ICONS_CSS);
        helpRouterVariables.setAttribute('rel', 'stylesheet');
        helpRouterVariables.setAttribute(
            'href',
            EU_CHAT_BOT_URLS.FORD_VARIABLES_CSS
        );

        document.body.appendChild(helpRouterFonts);
        document.body.appendChild(helpRouterIcons);
        document.body.appendChild(helpRouterVariables);

        if (process.env.REACT_APP_ACTIVE_PROFILE === 'prod') {
            helpRouterScript.setAttribute('type', 'text/javascript');
            helpRouterScript.setAttribute(
                'src',
                EU_CHAT_BOT_URLS.PROD_CHAT_BOT_BUNDLE_JS
            );
            helpRouterLink.setAttribute('rel', 'stylesheet');
            helpRouterLink.setAttribute('type', 'text/css');
            helpRouterLink.setAttribute(
                'href',
                EU_CHAT_BOT_URLS.PROD_CHAT_BOT_BUNDLE_CSS
            );
            document.body.appendChild(helpRouterScript);
            document.body.appendChild(helpRouterLink);
        } else {
            helpRouterScript.setAttribute('type', 'text/javascript');
            helpRouterScript.setAttribute(
                'src',
                EU_CHAT_BOT_URLS.PERF_CHAT_BOT_BUNDLE_JS
            );
            helpRouterLink.setAttribute('rel', 'stylesheet');
            helpRouterLink.setAttribute('type', 'text/css');
            helpRouterLink.setAttribute(
                'href',
                EU_CHAT_BOT_URLS.PERF_CHAT_BOT_BUNDLE_CSS
            );
            document.body.appendChild(helpRouterScript);
            document.body.appendChild(helpRouterLink);
        }
    }
    public loadContentSquareScript() {
        const contentSquareScript = document.createElement('script');
        contentSquareScript.type = 'text/plain';
        contentSquareScript.id = 'contentSquareScript';
        contentSquareScript.setAttribute('class', 'optanon-category-2-4');
        const setSrc = (): string => {
            return process.env.REACT_APP_ACTIVE_PROFILE !== 'prod'
                ? '//t.contentsquare.net/uxa/2b016d96cee86.js'
                : '//t.contentsquare.net/uxa/9dd4e0033cb51.js';
        };
        contentSquareScript.innerHTML = `
            window._uxa = window._uxa || [];
            if (typeof CS_CONF === 'undefined') {
                window._uxa.push(['setPath', window.location.pathname + window.location.hash.replace('#', '?__')]);
                var mt = document.createElement('script');
                mt.type = 'text/javascript';
                mt.async = true;
                mt.src = '${setSrc()}';
                document.getElementsByTagName('head')[0].appendChild(mt);
            } else {
                window._uxa.push(['trackPageview', window.location.pathname + window.location.hash.replace('#', '?__')]);
            }
        `;
        document.body.appendChild(contentSquareScript);
    }
}

export const scriptService = new ScriptService();
